import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import env from './modules/env'
import scroll from './modules/scroll'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    env,
    scroll
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js